import { DEBOUNCE_TIME } from 'common/utilities/timeout/timeout';
import debounce from 'debounce';
import { useCallback, useEffect, useState } from 'react';

export interface ViewportSize {
  width: number; height: number;
}

/**
 * Use document.body.clientWidth/Height to get accurate dimensions without scrollbar
 * @see https://stackoverflow.com/a/8340177
 */
function useViewportSize() {
  const [size, setSize] = useState<ViewportSize>({
    width: document.body.clientWidth, height: document.body.clientHeight,
  });

  const handleResize = () => {
    setSize({ width: document.body.clientWidth, height: document.body.clientHeight });
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedHandleResize = useCallback(
    debounce(() => handleResize(), DEBOUNCE_TIME.resize),
    [],
  );

  useEffect(() => {
    window.addEventListener('resize', debouncedHandleResize);
    return () => {
      window.removeEventListener('resize', debouncedHandleResize);
    };
  }, [debouncedHandleResize]);

  return size;
}

export default useViewportSize;
